// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__7zmAa","search":"Settings_search__2vZw7","filter":"Settings_filter__2cHBx"};